import * as React from "react";
import type { SVGProps } from "react";
const SvgKtvHeikinashiIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="ktv_heikinashi_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M704 85.333A42.667 42.667 0 0 1 746.667 128v87.083a128 128 0 0 1 106.666 126.25v213.334a128 128 0 0 1-128 128h-42.666a128 128 0 0 1-128-128V341.333a128 128 0 0 1 106.666-126.25V128A42.667 42.667 0 0 1 704 85.333zm21.333 213.334h-42.666A42.667 42.667 0 0 0 640 341.333v213.334a42.667 42.667 0 0 0 42.667 42.666h42.666A42.667 42.667 0 0 0 768 554.667V341.333a42.667 42.667 0 0 0-42.667-42.666zM320 128a42.667 42.667 0 0 1 42.667 42.667v87.082A128 128 0 0 1 469.333 384v384a128 128 0 0 1-128 128h-42.666a128 128 0 0 1-128-128V384a128 128 0 0 1 106.666-126.25v-87.083A42.667 42.667 0 0 1 320 128zm21.333 213.333h-42.666A42.667 42.667 0 0 0 256 384v384a42.667 42.667 0 0 0 42.667 42.667h42.666A42.667 42.667 0 0 0 384 768V384a42.667 42.667 0 0 0-42.667-42.667z"
    />
  </svg>
);
export default SvgKtvHeikinashiIcon;
